import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CoachGroupsListService {
  onGroupFilterChange = new BehaviorSubject(null);

  constructor() {
  }
}
